<template>
	<app-layout>
		<div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
			<br>

			<progressstep step="4"></progressstep>

			<div class="">

				<div class="d-flex">
					<div class="detail">
						<div class="my-2">
							<div class="font-semibold text-lg text-gray-800 leading-tight">Checkout</div>
							<p class="text-xs">View the details of checkout details record.</p>
						</div>

						<details>
							<summary>
								<div class="text-base font-medium">
									<h6>Tenant</h6>
									<span class="plus">{{ organisationName }}</span>
								</div>
							</summary>
						</details>
						<details>
							<summary>
								<div class="text-base font-medium">
									<h6>Billing Details</h6>
								</div>
								<div class="grid grid-cols-2 gap-4">
									<div class="text-gray-800 font-bold text-xs ml-4">{{ billingName }}</div>
									<!-- ... -->
									<div class="flex justify-end">
										<div class="text-gray-700 text-sm ml-4">GSTIN:</div>
										&nbsp; &nbsp;
										<div class="text-gray-800 font-bold text-xs font-bold">
											{{ billingGstin }}
										</div>
									</div>
								</div>

								<div class="grid grid-cols-2 gap-4">
									<div class="text-gray-800 font-bold text-xs ml-4">{{ billingAddress }}</div>
									<!-- ... -->
									<div class="flex justify-end">
										<div class="text-gray-700 text-sm ml-4">PAN:</div>
										&nbsp; &nbsp;
										<div class="text-gray-800 font-bold text-xs font-bold">{{ billingPan }}</div>
									</div>
								</div>
							</summary>
						</details>
						<details>
							<summary>
								<div class="text-base font-medium">
									<h6>Product Details</h6>
								</div>

								<div class="grid grid-cols-2 gap-4">
									<div class="text-gray-700 text-sm ml-4">Product</div>
									<!-- ... -->
									<div class="justify-end text-gray-800 font-bold text-xs">
										{{ selectedProductFamilyName }}
									</div>
								</div>
								<div class="grid grid-cols-2 gap-4">
									<div class="text-gray-700 text-sm ml-4">Plan</div>
									<!-- ... -->
									<div class="justify-end text-gray-800 font-bold text-xs">
										{{ subscriptionPlan }}
									</div>
								</div>
								<div class="grid grid-cols-2 gap-4">
									<div class="text-gray-700 text-sm ml-4">Frequency</div>
									<!-- ... -->
									<div class="justify-end text-gray-800 font-bold text-xs">
										{{ frequency }}
									</div>
								</div>
							</summary>
						</details>
					</div>
					<div class="Yorder">

						<sum class="sums">
							<div class="grid grid-cols-2 gap-4 mb-2">
								<div class="font-semibold text-lg text-gray-800 leading-tight">Order Summary</div>
								<!-- ... -->
							</div>
						</sum>

						<table>

							<!-- <tr>
					<th colspan="2">Order Summary</th>
					</tr> -->

							<details>
								<summary class="sum">

									<div class="grid grid-cols-2 gap-4 my-1">
										<div class="text-gray-700 text-sm ml-4 ">Price/User</div>
										<!-- ... -->
										<div class="flex justify-end">
											&nbsp; &nbsp;
											<div class="text-gray-800 font-bold text-xs">
												{{ subscriptionPrice }}
											</div>
										</div>
									</div>
								</summary>
							</details>
							<!-- pricing user end -->
							<!-- <tr>
					<td>No. of User</td>
					<td>
						{{ numberOfUsers }}
					</td>
					</tr> -->

							<!-- no. of user start -->
							<details>
								<summary class="sum">

									<div class="grid grid-cols-2 gap-4">
										<div class="text-gray-700 text-sm ml-4">No. of User</div>
										<!-- ... -->
										<div class="flex justify-end">
											&nbsp; &nbsp;
											<div class="text-gray-800 font-bold text-xs">
												{{ numberOfUsers }}
											</div>
										</div>
									</div>
								</summary>
							</details>
							<!-- no. of user end -->
							<!-- <tr>
					<td>Total</td>
					<td>{{ totalAmount }}</td>
					</tr> -->

							<!-- total amount start -->
							<details>
								<summary class="sum">

									<div class="grid grid-cols-2 gap-4">
										<div class="text-gray-700 text-sm ml-4">Total</div>
										<!-- ... -->
										<div class="flex justify-end">
											&nbsp; &nbsp;
											<div class="text-gray-800 font-bold text-xs">
												{{ totalAmount }}
											</div>
										</div>
									</div>
								</summary>
							</details>
							<!-- total amount end -->
							<!-- <tr>
					<td>GST</td>
					<td>{{ gstValue }}</td>
					</tr> -->



							<!-- igst start from here -->
							<details v-show="isIGST">
								<summary class="sum">
									<div class="grid grid-cols-2 gap-4">
										<div class="text-gray-700 text-sm ml-4">IGST</div>
										<!-- ... -->
										<div class="flex justify-end">
											&nbsp; &nbsp;
											<div class="text-gray-800 font-bold text-xs">
												{{ gstValue }}
											</div>
										</div>
									</div>
								</summary>
							</details>
							
							<!-- sgst start from here -->
							<details v-show="!isIGST">
								<summary class="sum">
									<div class="grid grid-cols-2 gap-4">
										<div class="text-gray-700 text-sm ml-4">SGST</div>
										<!-- ... -->
										<div class="flex justify-end">
											&nbsp; &nbsp;
											<div class="text-gray-800 font-bold text-xs">
												{{ sgstValue }}
											</div>
										</div>
									</div>
								</summary>
							</details>

							<!-- cgst start from here -->
							<details v-show="!isIGST">
								<summary class="sum">
									<div class="grid grid-cols-2 gap-4">
										<div class="text-gray-700 text-sm ml-4">CGST</div>
										<!-- ... -->
										<div class="flex justify-end">
											&nbsp; &nbsp;
											<div class="text-gray-800 font-bold text-xs">
												{{ cgstValue }}
											</div>
										</div>
									</div>
								</summary>
							</details>

							<!-- gst end -->


							<!-- gst end -->

							<!-- <tr>
					<td>Order Value</td>
					<td>{{ orderValue }}</td>
					</tr> -->

							<!-- roundOff start from here -->
							<details>
								<summary class="sum">
									<div class="grid grid-cols-2 gap-4">
										<div class="text-gray-700 text-sm ml-4">Round Off</div>
										<!-- ... -->
										<div class="flex justify-end">
											&nbsp; &nbsp;
											<div class="text-gray-800 font-bold text-xs">
												{{ roundOffValue }}
											</div>
										</div>
									</div>
								</summary>
							</details>

							<!-- order value start  -->
							<details>
								<summary class="sum">

									<div class="grid grid-cols-2 gap-4">
										<div class="text-gray-700 text-sm ml-4">Order Value</div>
										<!-- ... -->
										<div class="flex justify-end">
											&nbsp; &nbsp;
											<div class="text-gray-800 font-bold text-xs">
												{{ orderValue }}
											</div>
										</div>
									</div>
								</summary>
							</details>
							<!-- order value end -->
						</table>
						<br />

						<!-- button start from here -->
						<div>
							<!-- <button v-if="isOrderHidden" v-on:click="placeOrder()" class=" btn1mx-2 rounded bg-green-500 px-4 py-2 text-white">Place Order</button> -->
							<!-- button group starts -->
							<div>
								<button id="pay_now_btn" v-on:click="startPayment()"
									class="rounded bg-green-500 px-4 py-2 text-white">
									Pay Now
								</button>
								<button id="link_payment_btn" v-on:click="updatePayment()"
									class=" rounded-sm bg-blue-500 px-4 py-2 text-white">
									Link Payment
								</button>
								<button id="pay_later_btn" v-on:click="payLater()"
									class=" border-2 rounded-sm border-green-500 px-4 py-2">
									Pay Later
								</button>
							</div>
							<!-- button group ends -->
						</div>
						<!-- Yorder -->
					</div>
				</div>
			</div>
		</div>
	</app-layout>
</template>

<script>
import Progressstep from "../Views/Components/UpgradeProgressbar.vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";

export default {
  props: {
    subscriptionPlanId: String,
    subscriptionPlan: String,
    productId: String,
    product: String,
    subscriptionPriceId: String,
    subscriptionPriceName: String,
    subscriptionPrice: String,
    organisationName: String,
    organisationId: String,
    billingId: String,
    frequency: String,
    billingName: String,
    billingAddress: String,
    billingGstin: String,
    billingPan: String,
    numberOfUsers: String,
    billingGstin: String,
    orderValue: Number,
    totalAmount: String,
    razorpayAmount: Number,
    inventoryDetailId: String,
    orderId: String,

    gstValue: String,
    isIGST: Boolean,
    sgstValue: String,
    cgstValue: String,
    roundOffValue: String,
    selectedProductFamilyName: String,
    subscriptionProductId: String,
    billingAddressId: String,
  },

  components: {
    Progressstep,
    AppLayout,
    PageTitle,
  },
  data() {
    return {
      title: "Checkout",
    };
  },
  methods: {
    startPayment() {
      var productId = this.productId;
      var product = this.product;
      var subscriptionPlanId = this.subscriptionPlanId;
      var subscriptionPlan = this.subscriptionPlan;
      var subscriptionPriceId = this.subscriptionPriceId;
      var subscriptionPriceName = this.subscriptionPriceName;
      var subscriptionPrice = this.subscriptionPrice;
      var organisationId = this.organisationId;
      var organisationName = this.organisationName;
      var billingId = this.billingId;
      var frequency = this.frequency;
      var billingName = this.billingName;
      var numberOfUsers = this.numberOfUsers;
      var orderValue = this.orderValue;
      var totalAmount = this.totalAmount;
      var razorpayAmount = this.razorpayAmount;
      var inventoryDetailId = this.inventoryDetailId;
      var inertia = this.$inertia;
      var orderId = this.orderId;
      var gstValue = this.gstValue;
      var isIGST = this.isIGST;
      var sgstValue = this.sgstValue;
      var cgstValue = this.cgstValue;
      var roundOffValue = this.roundOffValue;
      var selectedProductFamilyName = this.selectedProductFamilyName;
      var subscriptionProductId = this.subscriptionProductId;
      var billingAddressId = this.billingAddressId;

      var options = {
        // key: "rzp_test_pDRncN9KH6IsVC",
        key: "rzp_test_elwavYnbuASrKh", // Enter the Key ID generated from the Dashboard
        amount: this.razorpayAmount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        currency: "INR",
        name: "Aruvaa",
        description: "Test Transaction",
        image: "imgs/aruvaa_logo.png",
        // "order_id": this.orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
        handler: function (response) {
          // make network call and send the response values to server

          var data = {
            productId: productId,
            product: product,
            subscriptionPlanId: subscriptionPlanId,
            subscriptionPlan: subscriptionPlan,
            subscriptionPriceId: subscriptionPriceId,
            subscriptionPriceName: subscriptionPriceName,
            subscriptionPrice: subscriptionPrice,
            organisationId: organisationId,
            organisationName: organisationName,
            billingId: billingId,
            frequency: frequency,
            billingName: billingName,
            numberOfUser: numberOfUsers,
            totalAmount: totalAmount,
            orderValue: orderValue,
            razorpayPaymentid: response.razorpay_payment_id,
            razorpayAmount: razorpayAmount,
            inventoryDetailId: inventoryDetailId,
            orderId: orderId,

            gstValue: gstValue,
            isIGST: isIGST,
            sgstValue: sgstValue,
            cgstValue: cgstValue,
            roundOffValue: roundOffValue,
            selectedProductFamilyName: selectedProductFamilyName,
            subscriptionProductId: subscriptionProductId,
            billingAddressId: billingAddressId,
          };

          inertia.post(route("marketplaces.upgradepayment"), data);
        },
        notes: {
          address: "Aruvaa",
        },
        theme: {
          color: "#3399cc",
        },
      };

      var rzp1 = new Razorpay(options);
      rzp1.on("payment.failed", function (response) {
        alert(response.error.code);
        document.querySelector(".orderMessageSuccess").style.display = "none";
        document.querySelector(".orderMessageFailure").style.display = "block";
      });

      rzp1.open();
    },

    savePaymentsInfo() {
      let urlParams = new URLSearchParams(window.location.search);
      this.productId = urlParams.get("product_id");
      this.organisationId = urlParams.get("organisation_id");
      axios.get("tenants/list").then((response) => {
        this.tenantData = response.data.results.data;
      });
    },

    updatePayment() {
      alert("Link Payment");
    },

    payLater() {
      var productId = this.productId;
      var product = this.product;
      var subscriptionPlanId = this.subscriptionPlanId;
      var subscriptionPlan = this.subscriptionPlan;
      var subscriptionPriceId = this.subscriptionPriceId;
      var subscriptionPriceName = this.subscriptionPriceName;
      var subscriptionPrice = this.subscriptionPrice;
      var organisationId = this.organisationId;
      var organisationName = this.organisationName;
      var billingId = this.billingId;
      var frequency = this.frequency;
      var billingName = this.billingName;
      var numberOfUsers = this.numberOfUsers;
      var orderValue = this.orderValue;
      var totalAmount = this.totalAmount;
      var inventoryDetailId = this.inventoryDetailId;
      var inertia = this.$inertia;
      var orderId = this.orderId;
      var gstValue = this.gstValue;
      var isIGST = this.isIGST;
      var sgstValue = this.sgstValue;
      var cgstValue = this.cgstValue;
      var roundOffValue = this.roundOffValue;

      var data = {
        productId: productId,
        product: product,
        subscriptionPlanId: subscriptionPlanId,
        subscriptionPlan: subscriptionPlan,
        subscriptionPriceId: subscriptionPriceId,
        subscriptionPriceName: subscriptionPriceName,
        subscriptionPrice: subscriptionPrice,
        organisationId: organisationId,
        organisationName: organisationName,
        billingId: billingId,
        frequency: frequency,
        billingName: billingName,
        numberOfUser: numberOfUsers,
        totalAmount: totalAmount,
        orderValue: orderValue,
        inventoryDetailId: inventoryDetailId,
        orderId: orderId,

        gstValue: gstValue,
        isIGST: isIGST,
        sgstValue: sgstValue,
        cgstValue: cgstValue,
        roundOffValue: roundOffValue,
      };

      inertia.post(route("marketplaces.paylater"), data);
    },
  },
  mounted() {
    console.log("IGST", this.gstValue);
    console.log("checkout mounted innventory id ", this.inventoryDetailId);
  },
};
</script>

<style>
.d-flex {
  display: flex;
  flex-direction: row;
  /* background: #f6f6f6; */
  border-radius: 0 0 5px 5px;
  padding: 8px 25px;
}

.left {
  flex: 4;
}

.detail {
  flex: 4;
  padding: 15px 25px;
  margin: 5px 10px 15px 0px;
  border: 1px solid #dadada;
  background-color: white;
  height: 600px;
}

.Yorder {
  flex: 2;
}

/* .title {
	background: -webkit-gradient(
	  linear,
	  left top,
	  right bottom,
	  color-stop(0, #5195a8),
	  color-stop(100, #70eaff)
	);
	background: -moz-linear-gradient(top left, #5195a8 0%, #70eaff 100%);
	background: -ms-linear-gradient(top left, #5195a8 0%, #70eaff 100%);
	background: -o-linear-gradient(top left, #5195a8 0%, #70eaff 100%);
	background: linear-gradient(to bottom right, #5195a8 0%, #70eaff 100%);
	border-radius: 5px 5px 0 0;
	padding: 12px;
	color: #f6f6f6;
  } */
h2 {
  margin: 0;
  padding-left: 15px;
}

h4 {
  margin-bottom: 0rem;
  font-weight: 500;
  line-height: 1.2;
}

.required {
  color: red;
}

label,
table {
  display: block;
  margin: 15px;
}

label > span {
  float: left;
  width: 25%;
  margin-top: 12px;
  padding-right: 10px;
}

select {
  width: 72%;
  height: 45px;
  padding: 5px 10px;
  margin-bottom: 10px;
}

.Yorder {
  margin-top: 5px;
  height: 600px;
  padding: 20px;
  border: 1px solid #dadada;
  background-color: white;
}

table {
  margin: 0;
  padding: 0;
}

th {
  border-bottom: 1px solid #dadada;
  padding: 10px 0;
}

tr {
  border-bottom: 1px solid #dadada;
}

tr > td:nth-child(1) {
  text-align: left;
  color: #2d2d2a;
}

tr > td:nth-child(2) {
  text-align: right;
  color: #52ad9c;
  margin-right: 40px;
}

td {
  /* border-bottom: 1px solid #dadada; */
  padding: 10px 55px 10px 0;
}

/* p{
	display: block;
	color: #888;
	margin: 0;
	padding-left: 25px;
  } */
.Yorder > div {
  padding: 15px 0;
}

button {
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  border: none;
  border-radius: 30px;
  background: #52ad9c;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
}

button:hover {
  cursor: pointer;
  background: #428a7d;
}

/* left detail css */
section {
  width: 90%;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

section + section {
  margin-top: 2.5em;
}

summary {
  /* background-color: #fff; */
  position: relative;
  /* cursor: pointer; */
  padding: 0.6em 0.3em;
  list-style: none;
}

summary::-webkit-details-marker {
  display: none;
}

summary:hover {
  background-color: #f2f5f9;
}

summary .sums:hover {
  background-color: #ffffff !important;
}

summary div {
  display: flex;
  align-items: center;
}

summary h5 {
  display: flex;
  flex-direction: column;
}

summary small {
  color: #999;
  font-size: 15px;
}

summary strong {
  font-weight: 600;
  font-size: 18px;
}

summary span:first-child {
  width: 2rem;
  height: 2rem;
  border-radius: 10px;
  background-color: #e0ece4;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  margin-right: 1.25em;
}

/* summary span:first-child svg {
	width: 2.25rem;
	height: 2.25rem;
  } */
summary span:last-child {
  font-weight: 700;
  margin-left: auto;
}

summary:focus {
  outline: none;
}

summary .plus {
  color: #999;
}

summary span:last-child {
  font-weight: 700;
}

summary .plu {
  margin-top: 4px;
  color: #999;
  margin-left: auto;
}

details {
  border-bottom: 1px solid #dadada;
}

/* details:first-of-type {
	border-top: 1px solid #dadada;
  } */

img,
video {
  max-width: 50%;
  height: auto;
}
</style>